import {fontStyles, theme} from '@styles/theme';
import styled from 'styled-components';
import {ButtonProps} from './Button';

export const BtnOutlined = styled.button<ButtonProps>`
  ${fontStyles.bodyM}
  white-space: ${({noWrap}) => (noWrap ? 'nowrap' : 'normal')};
  color: ${({redButton}) =>
    redButton ? theme.colors.signalRed00 : theme.colors.accent01};
  background-color: ${theme.colors.basic08};
  border: 1px solid ${theme.colors.accent00};
  border-color: ${({redButton}) =>
    redButton ? theme.colors.signalRed00 : theme.colors.accent00};
  border-radius: ${theme.roundedMedium};
  transition: all 0.4s;
  cursor: pointer;
  padding: ${({size}) =>
    size == 'big' ? '10px 24px' : size == 'regular' ? '8px 18px' : '6px 14px'};
  width: ${({fullWidth}) => (fullWidth ? '100%' : 'fit-content')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({size}) => (size == 'big' ? '16px' : size == 'regular' ? '10px' : '6px')};
  &:hover {
    background-color: ${({redButton}) =>
      redButton ? theme.colors.basic08 : theme.colors.accent02};
    border-color: ${({redButton}) =>
      redButton ? theme.colors.signalRed01 : theme.colors.accent00};
  }
  &:active {
    background-color: ${({redButton}) =>
      redButton ? theme.colors.basic08 : theme.colors.accent02};
    border-color: ${({redButton}) =>
      redButton ? theme.colors.signalRed01 : theme.colors.accent00};
  }
`;

export const BtnFilled = styled.button<ButtonProps>`
  ${fontStyles.bodyM}
  white-space: ${({noWrap}) => (noWrap ? 'nowrap' : 'normal')};
  color: ${theme.colors.basic08};
  background-color: ${({redButton}) =>
    redButton ? theme.colors.signalRed00 : theme.colors.accent00};
  border: 0;
  border-radius: ${theme.roundedMedium};
  transition: all 0.4s;
  cursor: pointer;
  padding: ${({size}) =>
    size == 'big' ? '10px 24px' : size == 'regular' ? '8px 18px' : '6px 14px'};
  width: ${({fullWidth}) => (fullWidth ? '100%' : 'fit-content')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({size}) => (size == 'big' ? '16px' : size == 'regular' ? '10px' : '6px')};
  &:hover {
    background-color: ${({redButton}) =>
      redButton ? theme.colors.signalRed01 : theme.colors.accent01};
  }
  &:active {
    background-color: ${({redButton}) =>
      redButton ? theme.colors.signalRed01 : theme.colors.accent01};
  }
`;

export const BtnDisabled = styled.button<ButtonProps>`
  ${fontStyles.bodyM}
  white-space: ${({noWrap}) => (noWrap ? 'nowrap' : 'normal')};
  color: ${theme.colors.basic04};
  border: ${({variant}) =>
    variant === 'outlined' ? `1px solid ${theme.colors.basic05}` : '0'};
  border-radius: ${theme.roundedMedium};
  background-color: ${({variant}) =>
    variant === 'outlined' ? theme.colors.basic08 : theme.colors.basic06};
  transition: all 0.4s;
  padding: ${({size}) =>
    size == 'big' ? '10px 24px' : size == 'regular' ? '8px 18px' : '6px 14px'};
  pointer-events: none;
  width: ${({fullWidth}) => (fullWidth ? '100%' : 'fit-content')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({size}) => (size == 'big' ? '16px' : size == 'regular' ? '10px' : '6px')};
  & > div span {
    filter: invert(0.5);
  }
`;

export const BtnText = styled.button<ButtonProps>`
  ${fontStyles.bodyM}
  white-space: ${({noWrap}) => (noWrap ? 'nowrap' : 'normal')};
  color: ${theme.colors.accent00};
  background-color: transparent;
  border: 0;
  border-radius: ${theme.roundedMedium};
  transition: all 0.4s;
  cursor: pointer;
  padding: ${({size}) =>
    size == 'big' ? '10px 24px' : size == 'regular' ? '8px 18px' : '6px 14px'};
  width: ${({fullWidth}) => (fullWidth ? '100%' : 'fit-content')};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({size}) => (size == 'big' ? '16px' : size == 'regular' ? '10px' : '6px')};
`;

export const ButtonWrapper = styled.div`
  a {
    width: fit-content;
    height: fit-content;
  }
`;

export const ImageWrapper = styled.div<{
  iconSrcSizes: {width: number; height: number};
  margin?: string;
}>`
  min-width: 15px;
  min-height: 15px;
  max-width: 32px;
  max-height: 32px;
  width: ${({iconSrcSizes}) => (iconSrcSizes ? `${iconSrcSizes.width}px` : '15px')};
  height: ${({iconSrcSizes}) => (iconSrcSizes ? `${iconSrcSizes.height}px` : '12px')};
  margin: ${({margin}) => margin ?? '0'};
`;
